function now() {
    return new Date()
}

function getNowReducedMinutes(minutes: number) {
    return new Date(now().getTime() - (minutes * 60 * 1000)).getTime()
}
export {
    getNowReducedMinutes
}